import * as React from 'react'
import { tasteType } from '@/model/wine'

import {
  Container,
  LeftLabel,
  RightLabel,
  BarContainer,
  BarOutter,
  BarInner
} from './style'

const Item = ({ item }) => {
  const { min, max, value } = item

  return (
    <Container>
      <LeftLabel>{ min }</LeftLabel>
      <BarContainer>
        <BarOutter>
          <BarInner value={ value } />
        </BarOutter>
      </BarContainer>
      <RightLabel>{ max }</RightLabel>
    </Container>
  )
}

Item.propTypes = {
  item: tasteType
}

export default Item
